<template>
  <div class="app_view">
    <Header></Header>
    <div class="dash_body">
      <div class="me_left">
        <div class="info_left">
          <v-btn outlined @click.stop="showNewModal = true" color="primary">
            <v-icon>add</v-icon>Crear Tienda
          </v-btn>
          <div class="menu_data">
            <v-list shaped>
              <v-subheader>GENERALES</v-subheader>
              <v-list-item-group v-model="flaItem" color="primary">
                <v-list-item v-for="item in items" :key="item.text" router :to="item.route">
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-subheader>CUENTA</v-subheader>
                <v-list-item v-for="item in config" :key="item.text">
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </div>
        </div>
      </div>
      <div class="me_center">
        <!-- nueva tienda -->
        <NewShop :visible="showNewModal" @close="showNewModal = false" />
        <!-- alerta general -->
        <AlertMsj :visible="getAlertFlat" />
        <div class="ctn_data">
          <!-- ruta anidada  -->
          <router-view />
        </div>
      </div>
      <div class="me_right">
        <div class="icon-center">
          <v-btn class="ico-data" color="#3c4043" to="/about" icon>
            <v-icon color="#ff0000">mdi-youtube-subscription</v-icon>
          </v-btn>
          <v-btn class="ico-data" color="#3c4043" to="/about" icon>
            <v-icon class="insta">mdi-instagram</v-icon>
          </v-btn>
          <v-btn class="ico-data" color="#3c4043" to="/about" icon>
            <v-icon class="material-icons-outlined">mdi-post</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Header from "@/components/dashboard/HeaderDashboard.vue";
import NewShop from "@/components/shop/NewShop.vue";
import AlertMsj from "@/components/dashboard/AlertMsj.vue";
export default {
  name: "Dashboard",
  components: {
    Header,
    NewShop,
    AlertMsj
  },
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: "Dashboard"
  },
  data() {
    return {
      showNewModal: false,
      flaItem: 0,
      items: [
        {
          text: "Tiendas",
          icon: "mdi-store-outline",
          route: "/dashboard/shops"
        },
        {
          text: "Categoria",
          icon: "mdi-tag-text-outline",
          route: "/dashboard/categories"
        },
        {
          text: "Productos",
          icon: "mdi-tag-plus-outline",
          route: "/dashboard/products"
        },
        {
          text: "Clientes",
          icon: "mdi-briefcase-account-outline",
          route: "/dashboard/clients"
        },
        {
          text: "Pedidos",
          icon: "mdi-order-bool-ascending-variant",
          route: "/dashboard/orders"
        }
        // { text: 'Metodo de pago', icon: 'mdi-credit-card-plus-outline' },
        // { text: 'Marketing', icon: 'mdi-bullhorn-outline' },
        // { text: 'Avanzado', icon: 'mdi-tune' },
      ],
      config: [
        { text: "Historial", icon: "mdi-ballot-recount-outline" },
        { text: "Cuenta", icon: "mdi-account-circle-outline" }
      ]
    };
  },
  computed: {
    ...mapGetters(["getAlertFlat", "getAlertMsj"])
  }
};
</script>
<style lang="scss">
@import "@/assets/scss/base.scss";
.app_view {
  height: 100%;
}
.dash_body {
  display: flex;
  flex-direction: row;
  position: relative;
  //height: calc(100vh - 64px);
  height: 100vh;
  box-sizing: border-box;
  .me_left {
    width: 100%;
    max-width: 256px;
    border-right: #dadce0 1px solid;
    .info_left {
      padding: 20px 10px;
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
      .menu_data {
        margin: 20px -10px;
        .v-list {
          background-color: $bg-dash;
        }
        .v-list-item {
          min-height: 42px;
          .v-list-item__title {
            font-size: 0.9rem;
          }
          .v-list-item__icon {
            margin: 8px 25px 8px 0 !important;
          }
        }
      }

      button.v-btn {
        color: $color-grey-dash !important;
        border: 1px solid transparent;
        border-radius: 30px;
        height: 48px;
        width: 180px;
        min-width: 100px;
        overflow: hidden;
        font-size: 0.8rem;
        box-shadow: $shadow-1 !important;
        &:hover {
          box-shadow: $shadow-3 !important;
        }
        span.v-btn__content {
          i {
            font-size: 40px;
            color: $bg-color-500;
          }
        }
      }
    }
  }
  .me_center {
    flex: 1 1 auto;
    .name_view {
      padding: 20px;
      display: flex;
      flex-direction: row;
      //margin-left: 30px;
      .view-left {
        flex-basis: 80%;
        p {
          font-family: "Roboto Condensed", sans-serif;
          line-height: 1;
          font-size: 2rem;
          color: $color-text-dash;
          margin: 0;
          &.sub {
            font-size: 1rem;
          }
        }
      }
      .view-right {
        flex: 1 1 auto;
      }
    }
    .ctn_data {
      padding: 20px;
      .action-tablet {
        button {
          margin-right: 10px;
        }
      }
      // .section_quick {
      //   .title_quick {
      //   }
      //   .ctn_quick {
      //   }
      // }
      .v-data-table {
        background-color: $bg-dash;
        thead th {
          background-color: $bg-dash;
        }
      }
      .lb {
        font-family: "Roboto Condensed", sans-serif;
        font-size: 0.7rem;
        text-transform: uppercase;
        color: #fff;
        height: 15px;
        border-radius: 30px;
        width: 80px;
        // text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        &.lb_activo {
          background-color: $bar-active-dash;
        }
        &.lb_inactivo {
          background-color: $bar-inactive-dash;
        }
      }
    }
  }
  .me_right {
    border-left: #dadce0 1px solid;
    max-width: 56px;
    .icon-center {
      padding: 10px 5px;
      justify-content: center;
      button,
      a {
        margin-bottom: 9px;
      }
      i.insta {
        background: radial-gradient(
          circle at 30% 107%,
          #fdf497 0%,
          #fdf497 5%,
          #fd5949 45%,
          #d6249f 60%,
          #285aeb 90%
        );
        -webkit-text-fill-color: transparent;
      }
    }
  }
}
</style>
